import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pillows_all: FaireCategoryEntity = {
  token: "cat_pillows-all",
  type: "category",
  name: "All throw pillows & blankets",
  level: 3,
  parentToken: "cat_home-decor-pillows",
  href: "/category/home-decor/throw-pillows-blankets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
